import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApContentService } from '@ap/content';
import { ApError, ApErrorService } from '@ap/error';
import { ErrorContext } from '@ap/tokens-browser';

import content from './mijn-tokens-browser.content.json';
import { MijnTokensBrowserNavigation } from './mijn-tokens-browser.navigation';
import { MijnTokensBrowserService } from './mijn-tokens-browser.service';

/**
 * @module MijnTokensBrowserModule
 * @ngdoc component
 * @name MijnTokensBrowserComponent
 */
@Component({
    selector: 'mijn-tokens-browser',
    templateUrl: './mijn-tokens-browser.component.html',
    standalone: false
})
export class MijnTokensBrowserComponent implements OnInit, OnDestroy {
    public showNotification: boolean;
    public takeoverError: ApError;

    private readonly subscriptions: Subscription = new Subscription();

    public constructor(
        private readonly apErrorService: ApErrorService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly contentService: ApContentService,
        private readonly mijnTokensBrowserService: MijnTokensBrowserService,
        private readonly navigation: MijnTokensBrowserNavigation
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);

        this.subscriptions.add(
            this.apErrorService.error$().subscribe((error: ApError) => {
                this.takeoverError = error;
                this.changeDetectorRef.detectChanges();
            })
        );

        this.subscriptions.add(
            this.mijnTokensBrowserService.getShowNotification().subscribe((show: boolean) => {
                this.showNotification = show;
            })
        );

        if (this.mijnTokensBrowserService.browserIsIE()) {
            this.apErrorService.publish(new ApError(null, ErrorContext.MSIE));
        } else {
            this.subscriptions.add(
                this.mijnTokensBrowserService.hasIncompatibleBrowser().subscribe((isIncompatible) => {
                    if (isIncompatible) {
                        this.apErrorService.publish(new ApError(null, ErrorContext.INCOMPATIBLE_BROWSER));
                    }
                })
            );
        }
    }

    public isBrowserError(): boolean {
        return (
            !!this.takeoverError &&
            (this.takeoverError.context === ErrorContext.BUSINESS ||
                this.takeoverError.context === ErrorContext.MAX_TOKENS ||
                this.takeoverError.context === ErrorContext.MSIE ||
                this.takeoverError.context === ErrorContext.INCOMPATIBLE_BROWSER ||
                this.takeoverError.context === ErrorContext.DEFAULT)
        );
    }

    public onErrorAction(context: ErrorContext): void {
        if (context === ErrorContext.BUSINESS || context === ErrorContext.INCOMPATIBLE_BROWSER) {
            this.navigation.external(this.contentService.get('mijn.tokens.browser.login.link'));
        }
        if (context === ErrorContext.MSIE) {
            this.navigation.external(this.contentService.get('mijn.tokens.browser.msie.link'));
        }
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public onCloseNotification(): void {
        this.mijnTokensBrowserService.setShowNotification(false);
    }

    public getTitle(): string {
        return this.takeoverError ? '' : 'mijn.tokens.browser.title';
    }
}
